<template>
  <div class="modal fade" id="modalConfirmacion" name="kjsdfhsjdfh" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{titulo}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h5><span class="col-form-label">{{cuerpo}}</span></h5>
          <br />
          <div v-if="mostrarMotivo">
            <span class="col-form-label">¿Cual es el motivo?</span>
            <textarea class="form-control" id="motivoModalConfirmacion"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-primary" id="botonModalConfirmacion" data-dismiss="modal">Confirmar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'

  export default {
    props: ['accion'],
    data() {
      return {
        titulo: "",
        cuerpo: "",
        mostrarMotivo: true
      }
    },
    components: {

    },
    methods: {
      mostrar: function (titulo, cuerpo,accion) {
        this.titulo = titulo
        this.cuerpo = cuerpo
        $('#botonModalConfirmacion').attr("disabled", true)
        $("#motivoModalConfirmacion").val("")
        $("#motivoModalConfirmacion").keyup(this.validarMotivo);
        $('#modalConfirmacion').modal()
        $("#botonModalConfirmacion").unbind('click').click(accion);
      },
      validarMotivo: function (event) {//Valida que el motivo de desactivación o cancelación sea capturado
        var cantidadTexto = $(event.target).val().trim().length
          $('#botonModalConfirmacion').attr("disabled", cantidadTexto<=0)
      }
    },
    mounted: function () {

    }

  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Comun/Modales/ModalConfirmacion.vue